import "./GalleryModal.css";

import React from "react";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";

const style = {
  position: "absolute",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  height: "80%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const GalleryModal = ({ imgSrc }) => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <div className="gallery-page-imgs-img+modal-container">
      <img
        onClick={handleOpen}
        className="gallery-page-imgs-img"
        src={imgSrc}
        alt="Loading"
      ></img>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="asdasdasd">
          <img
            className="gallery-page-imgs-img-modal"
            src={imgSrc}
            alt="Loading"
          ></img>
        </Box>
      </Modal>
    </div>
  );
};
